/**
 * Unique identifiers for system email templates. Max length 100 chars.
 *
 * @see EmailTemplateEntity.systemSlug
 */
export enum EmailTemplateSystemSlug {
	INTERNAL_ORDER_LIST = 'internal_order_list',
	INVOICE_DETAIL = 'invoice_detail',
	ORDER_DETAIL = 'order_detail',
	VENDOR_QUOTE_REQUEST = 'vendor_quote_request',
	VENDOR_PURCHASE_ORDER = 'vendor_purchase_order',
	VENDOR_RECEIPT_ISSUE = 'vendor_receipt_issue',
	/**
	 * PD-13445 — Motor City Ice self-delivery proof-of-delivery email
	 * (order summary, signature, pre/post-stop photos, invoice PDF) sent
	 * to the customer after a trip stop is completed with delivered goods.
	 * Deliberately named "self" delivery to distinguish it from the future
	 * carrier-based delivery confirmation (tracking summary).
	 */
	SELF_DELIVERY_CONFIRMATION = 'self_delivery_confirmation',
}
